class GraphicUpload {
	constructor() {
		this._onComplete = null;

		this._dialog = Dialog.Modal('graphic-upload', _("Upload Graphic"), X_LARGE, null, UI.div(null, [
			UI.div('p-4', [
				UI.p('text-center', [
					UI.htm('label', 'input-file', [
						this._file = UI.input('file', null, null, {
							'change': this.imagePicked.bind(this)
						}, {
							'accept': 'image/png, image/jpg, image/jpeg'
						}),
						UI.span(null, _("Choose a file to upload..."))
					])
				]),
				UI.p('text-center', _("or")),
				UI.p('text-center', [
					UI.span('uri-input', [
						this._uri = UI.text(null, null, {
							'placeholder': _("Enter or paste image URL"),
						}),
						UI.btn('', _("Get file"), { 'click': this.url.bind(this, null) })
					])
				]),
				UI.p('text-center', _("or")),
				this._dropTarget = UI.div('upload-target norm', [
					UI.htm('h6', null, _("Drop image here")),
					UI.p(null, _("jpeg or png files only"))
				], {
					'dragover': () => {
						state(this._dropTarget, 'glow');
					},
					'dragleave': (ev) => {
						state(this._dropTarget);
					},
					'drop': this.imageDrop.bind(this)
				})
			])
		]));
	}

	open(onComplete, initialName) {
		this._onComplete = onComplete || null;
		this._initialName = initialName || _("New upload");
		onEv(window, 'dragover', this.dragOver);
		this._dialog.open(null, this.close.bind(this));
	}

	close() {
		remEv(window, 'dragover', this.dragOver)
		this._dialog.close();
	}

	imagePicked(ev) {
		this.file(this._file.files);
	}

	dragOver(ev) {
		ev.preventDefault();
	}

	imageDrop(ev){
		ev.preventDefault();
		stopEv(ev);
		state(this._dropTarget);

		if (ev.dataTransfer.getData('text/uri-list')) {
			this.url(ev.dataTransfer.getData('text/uri-list'));
		}
		else if (ev.dataTransfer.files) {
			this.file(ev.dataTransfer.files);
		}
	}
	
	url(url) {
		if (url === null) url = this._uri.value;
		try {
			new URL(url);
		} catch {
			makeToast('Please enter a valid image URL.');
			return;
		}
		this.finish();
		GraphicEditor.uploadUrl(url, this._onComplete, this._initialName);
	}

	file(files) {
		if (files.length > 1) {
			makeToast('Only one image at a time, processing the first.');
		}
		let file = files[0];
		if (file.type == 'image/jpeg' || file.type == 'image/jpg' || file.type == 'image/png'){
			this.finish();
			GraphicEditor.uploadFile(file, this._onComplete, this._initialName);
		}
		else {
			makeToast('Please select a png or jpeg image file.');
		}
	}
	
	finish() {
		this._file.value = '';
		this._uri.value = '';
		if (this._onComplete !== null) this.close();
	}
}
